export enum enumEntrySummaryType {
  FORMAL = 1,
  INFORMAL = 11,
}
